/* eslint-disable no-unused-vars */
import React from "react";
import Header from "../components/Header";
import Banner from "../sections/Banner";
import HowToPlay from "../sections/HowToPlay";
import Leaderboard from "../sections/Leaderboard";
import Economy from "../sections/Economy";
import Roadmap from "../sections/Roadmap";
import Contact from "../sections/Contact";
import Footer from "../components/Footer";
import About from "../sections/About";
const Home = ({ connect, balance, buyers }) => {
  return (
    <div className="font-sans text-white font-bold min-h-screen ">
      <Header connect={connect} />
      <Banner balance={balance} buyers={buyers} />
      <About />
      {/* <HowToPlay /> */}
      {/* <Leaderboard /> */}
      <Economy />
      <Roadmap />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
